import { useEffect, useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./careers.css";

gsap.registerPlugin(ScrollTrigger);

export default function Careers() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;

    const mm = gsap.matchMedia();

    mm.add(
      "(prefers-reduced-motion: no-preference)",
      () => {
        const content = section.querySelector(".careers-content");
        const image = section.querySelector(".careers-background");

        const timeline = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "top 75%",
            once: true,
          },
        });

        timeline
          .fromTo(
            image,
            { scale: 1.08 },
            { scale: 1, duration: 1.4, ease: "power2.out" },
            0,
          )
          .fromTo(
            content,
            { autoAlpha: 0, y: 28 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.85,
              ease: "power2.out",
              clearProps: "opacity,visibility,transform",
            },
            0.2,
          );
      },
      section,
    );

    return () => mm.revert();
  }, []);

  return (
    <section
      className="careers-section"
      ref={sectionRef}
      aria-labelledby="careers-title"
    >
      <div className="careers-background" aria-hidden="true" />
      <div className="careers-overlay" aria-hidden="true" />

      <div className="careers-inner">
        <div className="careers-content">
          <span className="careers-eyebrow">
            <span className="careers-eyebrow-dot" aria-hidden="true" />
            CAREERS
          </span>

          <h2 className="careers-title" id="careers-title">
            Build Your Career.
            <br />
            <span>Train Tomorrow's AI.</span>
          </h2>

          <p className="careers-description">
            We hire and train domain experts. Every new team member receives
            structured, in-house training before contributing to live projects
            and gains hands-on experience working on global AI projects with
            real-world impact. If you want to work where human judgment shapes
            machine intelligence, we're hiring.
          </p>

          <Link className="careers-cta" to="/careers">
            Build Your Career In AI
            <ArrowUpRight aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}
